import { ApiStore, Widget, rotationModes } from '@hart-estate/widget';
import '../assets/sass/index.sass';
import logo from '../assets/logo.png';

const API_URL = 'https://backend.estate.hart-digital.com';

const getParams = () => {
  const { searchParams } = new URL(document.location.toString());
  return {
    planId: searchParams.get('id'),
    crmPlanId: searchParams.get('crmPlanId'),
  }
}

const createWidget = async (logoUrl) => {
  const { planId, crmPlanId } = getParams();

  const widgetApi = new ApiStore(API_URL);
  const planData = crmPlanId
    ? await widgetApi.loadCrmWidgetData(crmPlanId)
    : await widgetApi.loadWidgetData(planId);

  const options = {
    ...planData.parsed,
    API_URL,
    logo,
    logoUrl,
    rotationMode: rotationModes.DEFAULT,
    tabs: ['panorama', 'rotation'],
    designType: 'standard',
    cursorType: 'circle',
    tabsButtonsDesign: 'two',
    locale: 'ru',
    branding: {
      name: 'Рижское лето',
      url: 'https://rigaleto.ru/?utm_source=3dtur120'
    }
  }

  new Widget('#widget', options);
}

createWidget('https://rigaleto.ru/?utm_source=3dtur120');
